export const LogoMark = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M22 4C22 4 25.5 12.5 31.5 14C37.5 15.5 40 22 40 22C40 22 32.5 24 30.5 29.5C28.5 35 22 40 22 40C22 40 19.5 31.5 13.5 30C7.5 28.5 4 22 4 22C4 22 11.5 20 13.5 14.5C15.5 9 22 4 22 4Z"
      stroke="#4A6B5D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
    />
    <circle cx="22" cy="22" r="4" fill="#8A7CA8" stroke="#FAF8F5" strokeWidth="1.5" />
    <path d="M22 10V14M22 30V34M10 22H14M30 22H34" stroke="#6E8E7F" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-serif text-xl tracking-tight text-ink">Bloom Paper Studio</span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-sage mt-1">Digital Downloads</span>
    </span>
  </span>
);
